import React, { useState } from "react";
import { useDispatch } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";
import { setWidgetInSheetParams, updateWidgetSettings } from "appRedux/actions/Actions";
import { Message, Switch, Button, Input } from "../../../BP2Components";

const ListFilteringSettings = (props) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      mapLocalizationFieldName: props.localizationFieldName,
      mapClickFilterColName: props.mapClickFilterColName,
      mapDefaultZoomLevel: props.defaultZoomLevel,
      mapViewListSerie: props.viewListSerie,
      mapListSerie: props.mapListSerie,
      mapIndependentSerie: props.mapIndependentSerie,
      mapPointColName: props.mapPointColName,
      mapDistanceColName: props.mapDistanceColName,
      mapAddressColName: props.mapAddressColName,
      showMap: props.showMap,
      showListName: props.showListName,
      filterByLocation: props.filterByLocation,
      distanceToFilter: props.distanceToFilter,
      maxDistanceToFilter: props.maxDistanceToFilter,
      setDistanceColumnHidden: props.setDistanceColumnHidden,
      name: props.name,
      columnProperties: props.columnProperties,
      selectedSerie: props.selectedSerie,
      listWidgetSeries: props.listWidgetSeries,
      priority: props.priority,
      stateChange: 0,
      id: props.id,
      xsWidth: props.xs,
      smWidth: props.sm,
      mdWidth: props.md,
      lgWidth: props.lg,
      xlWidth: props.xl,
      backgroundColourHex: props.backgroundColourHex,
      showPlacefinder: props.showPlacefinder,
      showUrlButton: props.showUrlButton,
      urlColumn: props.urlColumn,
      ulrButtonTitle: props.ulrButtonTitle,
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      dispatch(updateWidgetSettings(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="filterByLocation" className="widget-settings__inner__label">
                     <IntlMessages id="settings.filterByLocation" />:
                     <Switch
                        name="filterByLocation"
                        disabled={true}
                        onChange={(e) => handleSwitch(e, "filterByLocation")}
                        defaultChecked={props.filterByLocation}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="setDistanceColumnHidden">
                     <IntlMessages id="settings.setDistanceColumnHidden" />:
                     <Switch
                        name="setDistanceColumnHidden"
                        onChange={(e) => handleSwitch(e, "setDistanceColumnHidden")}
                        defaultChecked={props.setDistanceColumnHidden}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="distanceToFilter">
                     <IntlMessages id="settings.distanceToFilter" />:
                     <Input
                        type="number"
                        name="distanceToFilter"
                        onChange={handleChangeInput("distanceToFilter")}
                        min={1}
                        max={props.maxDistanceToFilter}
                        defaultValue={props.distanceToFilter}
                     />
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="maxDistanceToFilter">
                     <IntlMessages id="settings.maxDistanceToFilter" />:
                     <Input
                        type="number"
                        name="maxDistanceToFilter"
                        onChange={handleChangeInput("maxDistanceToFilter")}
                        min={1}
                        defaultValue={props.maxDistanceToFilter}
                     />
                  </label>
               </div>
               <Button className="gx-ml-4" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default ListFilteringSettings;
